export function accessCheck(role, required){
    if ( required.indexOf(role) >= 0 ){
        return true;
    }
    return false;
}